import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Store from 'lightningjs-redux';
import { HOME_PATH, navigateTo } from '../../routes/routes.utils';
import { removeSplashScreen } from '../../../logic/app/app.utils';
import { singleSignIn } from '../../../logic/pairing/platform/default';
import { getCurrentPairedUser } from '../../../logic/pairing/pairing.actions';
import { clearCache, loadNavigation } from '../../../logic/layout/layout.actions';
import { showPopupAction } from '../../../logic/popup/popup.actions';
import { setCloseReason } from '../../../logic/lifecycle/lifecycle.utils';
import { FATAL_ERROR_POPUP_ID } from '../../popups/popups.constants';
import { t } from '../../i18n';
import { Button } from '../../tornado/button/button.component';
import Spinner from '../../tornado/spinner/spinner.component';
import { rememberSSIDeclined } from '../pairing.utils';
import { defaultContext, getInitialStyle } from './tos.style';
import connect from './tos.connector';

export class TermsOfService extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Title: {
          text: {
            text: t('pairing.ssi.title'),
          },
        },
        Description: {
          text: {
            text: t('pairing.ssi.description'),
          },
        },
        Buttons: {
          Accept: {
            type: Button,
            label: t('pairing.ssi.accept'),
          },
          Decline: {
            type: Button,
            label: t('pairing.ssi.decline'),
          },
        },
        Spinner: {
          type: Spinner,
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._index = 0;
    this._style = defaultContext;
  }

  _active() {
    removeSplashScreen();
    this._unsubscribe = connect(this);
  }

  _inactive() {
    if (this._unsubscribe) {
      this._unsubscribe();
      this._unsubscribe = null;
    }
  }

  set deeplink(value) {
    this._deeplink = value;
  }

  _focus() {
    this._index = 0;
  }

  _handleLeft() {
    this._index = 0;

    return true;
  }

  _handleRight() {
    this._index = 1;

    return true;
  }

  _getFocused() {
    return this.tag('Buttons').children[this._index];
  }

  _handleEnter() {
    if (!this.tag('Buttons').visible) {
      return false;
    }

    if (this._index) {
      this._handleDecline();
    } else {
      this._handleAccept();
    }

    return true;
  }

  async _handleAccept() {
    this.patch({
      Buttons: { visible: false },
      Spinner: { visible: true },
    });

    const isPaired = await singleSignIn(true);
    if (isPaired) {
      await Store.dispatch(getCurrentPairedUser(true));

      Store.dispatch(clearCache());
      Store.dispatch(loadNavigation());

      navigateTo(this._deeplink || HOME_PATH, false);
    } else {
      setCloseReason('error');
      Store.dispatch(showPopupAction(FATAL_ERROR_POPUP_ID, {}));
    }
  }

  _handleDecline() {
    rememberSSIDeclined();

    navigateTo(HOME_PATH);
  }
}
